import { linkIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const InternalLink = createIcon({
  displayName: 'InternalLink',
  paths: [
    'M768 170.667v85.333h85.333c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667h-85.333v85.333c0 23.552-19.115 42.667-42.667 42.667s-42.667-19.115-42.667-42.667v-85.333h-85.333c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h85.333v-85.333c0-23.552 19.115-42.667 42.667-42.667s42.667 19.115 42.667 42.667zM255.997 853.333c-47.128 0-85.332-38.148-85.333-85.274v-426.816c0.001-47.126 38.205-85.243 85.332-85.243h170.669c23.553 0 42.668 19.115 42.668 42.667s-19.115 42.667-42.668 42.667h-170.667v426.667h426.668v-170.667c0-23.552 19.115-42.667 42.667-42.667s42.667 19.115 42.667 42.667v170.701c0 47.13-38.204 85.299-85.333 85.299h-426.67z'
  ],
  canvasPaths: canvasIconPaths(linkIcon)
})
